import ToggleButton from "@/components/shared/ToggleButton";
import AmountInput from "@/components/shared/AmountInput";

const ExpenseRow = ({ icon: Icon, label, expense, onUpdate, index }) => {
  const handleToggle = (isMonthly) => onUpdate(index, { ...expense, is_monthly: isMonthly });
  const handleAmountChange = (value) => {
    if (expense.is_monthly) {
      onUpdate(index, { ...expense, monthly_amount: value, yearly_amount: value * 12 });
    } else {
      onUpdate(index, { ...expense, yearly_amount: value, monthly_amount: value / 12 });
    }
  };

  return (
    <div className="flex items-center justify-between py-3 bg-gray-50 rounded-lg px-3 sm:px-4 expense-row-mobile" data-testid={`expense-row-${index}`}>
      <div className="flex items-center gap-2 sm:gap-3 shrink-0">
        <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-teal-50 flex items-center justify-center text-teal-600"><Icon size={14} /></div>
        <span className="text-gray-700 text-sm sm:text-base">{label}</span>
      </div>
      <div className="flex items-center gap-2 sm:gap-4 row-controls">
        <ToggleButton isMonthly={expense.is_monthly} onToggle={handleToggle} dataTestId={`expense-toggle-${index}`} />
        <AmountInput value={expense.is_monthly ? expense.monthly_amount : expense.yearly_amount} onChange={handleAmountChange} dataTestId={`expense-amount-${index}`} />
      </div>
    </div>
  );
};

export default ExpenseRow;
